import AdmissionDetails from './AdmissionDetails';

export default AdmissionDetails;
